export interface Version {
  number: number
  lastBussinessUpdate: string
}

export const version: Version = {
  number: 2,
  lastBussinessUpdate: '2019-07-24T10:04:26.928Z',
}

export default {
  common: {
    CZK: 'Kč',
    continue: 'Pokračovat',
    submit: 'Odeslat',
    close: 'Zavřít',
    back: 'Zpět',
    no: 'Ne',
    save: 'Uložit',
    saveChanges: 'Uložit změny',
    cancel: 'Zrušit',
    choose: 'Vyberte',
    cblValidationError: { title: 'Opravte, prosím, chyby ve formuláři' },
    iUnderstand: 'Rozumím',
    and: 'a',
    subTitle: 'Abychom mohli vyhodnotit Vaši žádost, potřebujeme od Vás správné údaje.',
    prefill: 'Předvyplnit formulář',
    yes: 'Ano',
  },
  validation: {
    required: 'Něco nám sem vyplňte',
    value_must_be_less_than: 'Hodnota musí být menší než {limit}',
    mustBeChecked: 'Musí být potvrzeno',
    atLeastOne: 'Alespoň jedna položka musí být vyplněna',
    mustBeNumeric: 'Musí to být číslo',
    mustBeInteger: 'Musí být celé číslo',
    mustBePositive: 'Musí být víc než nula',
    moreThanOrEqualTo: 'Hodnata musí být větší nebo rovna {limit}',
    mustBePositiveOrZero: 'Musí být kladné číslo nebo nula',
    moreThan: 'Hodnota musí být větší než {limit}',
    mustBeAtLeast:
      'Hodnota musí být minimálně {min, plural, one {# znak} few {# znaky} other {# znaků}}',
    mustBeNoMoreThan:
      'Nesmí být delší než {max, plural, one {# znak} few {# znaky} other {# znaků}} ',
    mustBeInTable: 'Musí být hodnota ze seznamu',
    mustBeCharactersLong: 'Musí mít {length, plural, one {# znak} few {# znaky} other {# znaků}}',
    invalidPhoneNumber: 'To nebude platné české číslo',
    invalidEmailAddress: 'To nebude správný e-mail',
    invalidDate: 'To nebude správné datum',
    hasNotSpecialCharacters: 'Použijte prosím písmena české abecedy',
    mustBeInTheFuture: 'Datum musí být v budoucnosti',
    mustBeInThePast: 'Datum musí být v minulosti',
    invalidBirthNumber: 'To nebude Vaše rodné číslo',
    invalidCity: 'Neplatné město',
    invalidZip: 'PSČ neexistuje',
    invalidEmploymentId: 'To nebude správné IČO',
    invalid_street: 'Chybný název ulice',
    must_include_only_numbers: 'Prosím použijte jen číslice.',
    must_include_only_letters_numbers: 'Prosím použijte jen číslice nebo písmena.',
  },
  availability: {
    button: '← Zpět',
    callUs: 'Potřebujete více informací?{br}Volejte na:',
    notification:
      'Od {start} proběhne pravidelná údržba našich systémů. Pokud máte rozdělanou nějakou práci, bude ztracena. Vraťte se prosím {endDay} po {endTime}, kdy vše zase poběží, jak má.',
    title:
      'Aby vše fungovalo, jak má, potřebují naše systémy pravidelnou údržbu.<br />{application}bude opět dostupná {day} v {time}.',
    text: 'Aby vše fungovalo, jak má, potřebují naše systémy pravidelnou údržbu.',
    time: '{application} bude opět dostupná {day} v {time}.',
  },
  errors: {
    retryModalDialog: {
      title: 'Něco se pokazilo, zkuste to znovu',
      titleNet: 'Došlo k výpadku připojení, zkuste to znovu',
      titleKO: 'Něco se pokazilo, pokračujte později',
      titleKoStop: 'Omlouváme se, něco se pokazilo',
      descriptionKO:
        'Mrzí nás to, chyba bude na naší straně. Prosím uložte si aktuální stav, dejte si 10 minut pauzu a pokračujte později.',
      description1:
        'Mrzí nás to, chyba bude na naší straně. Prosím zkuste to znovu. Nebo si uložte aktuální stav, dejte si 10 minut pauzu a pokračujte později.',
      description1Net:
        'Zkontrolujte své připojení k internetu a zkuste to znovu. Nebo si dejte 10 minut pauzu a pokračujte později.',
      descriptionKoStop:
        'Mrzí nás to, chyba bude na naší straně. Založte prosím novou žádost a vyplňte údaje znovu.',
      description3: 'Chcete se nás na něco zeptat?',
      callUs: 'Zavolejte nám',
      saveBtn: 'Uložit a pokračovat později',
      saveBtnStop: 'Ukončit a založit novou žádost',
      retryBtn: 'Zkusit znovu',
    },
    network: {
      title: 'Vaše připojení k Internetu nefunguje',
      description:
        'Zkontrolujte, prosím, Vaše připojení k internetu a případně opakujte akci znovu.',
    },
    server: { title: 'Nastala interní chyba serveru.' },
    serverRetry: {
      title: 'Nastala chyba při vyřizování požadavku.',
      description: 'Pokuste se tuto akci opakovat za chvíli znovu.',
    },
    unauthorized: { title: 'Chyba autorizace' },
    technicalDifficulties: {
      title: 'Proces nemohl být dokončen',
      text: 'Kvůli technickým obtížím nebylo možné proces dokončit.',
    },
    unexpectedError: 'Nastala neočekávaná chyba.',
    scoring: {
      title: 'Mrzí nás to, ale půjčku Vám nemůžeme schválit',
      note: 'Pokud máte dotaz, jak dál postupovat, kontaktujte nás.',
      callUs: 'Zavolejte nám',
      visitUs: 'Navštivte nás',
      prepareMeeting: 'Domluvit schůzku',
    },
  },
  components: {
    address: {
      city: 'Město',
      houseNumber: 'Číslo orientační',
      landRegistryNumber: 'Číslo popisné',
      street: 'Ulice',
      streetPlaceholder: 'Začněte psát',
      zip: 'PSČ',
    },
    TermText: {
      loanYears: '{years, plural, one {# rok} few {# roky} other {# let}}',
      loanMonths: '{months, plural, one {# měsíc} few {# měsíce} other {# měsíců}}',
    },
    stickyFooter: {
      progress: 'Pro pokračování přečtete celý dokument. Máte přečteno {progress}',
      info: 'Máte dotazy? Zavolejte nám',
    },
    callUs: 'Zavolejte nám na <u>{phone}</u>',
  },
  sidePanel: {
    topSection: { title: 'Průběh sjednání Vaší půjčky' },
    stepper: {
      loanSettings: 'Nastavení parametrů půjčky</br><b>{loanAmount}</b>',
      personalDetails: {
        title: 'Vyplnění údajů',
        personalData: 'Osobní údaje',
        incomesOutcomes: 'Příjmy a výdaje',
        offerForYou: 'Shrnutí',
      },
      loanConfig: 'Schválená žádost',
      income: 'Doložení příjmů',
      identity: 'Ověření identity',
      docs: 'Podpis smluv',
      pennyTransfer: 'Aktivační převod',
      money: 'Peníze k dispozici',
    },
    leaveButton: 'Uložit na později',
    branchQuestion: 'Raději na pobočce?',
    arrangeVisit: 'Domluvit schůzku',
    needs: {
      title: 'Ke sjednání potřebujete:',
      items: [
        'Občanský průkaz a věk nad 18 let',
        'Řidičský průkaz nebo cestovní pas',
        'Platit daně pouze v ČR',
        'Pouze české občanství',
        'Účet v české bance vedený na Vaše jméno',
        'Několik výpisů z běžného účtu pro doložení Vašich příjmů',
        'Chytrý mobilní telefon s českým číslem',
      ],
    },
  },
  basicLayout: {
    pageTitle: 'Rychlá půjčka na cokoliv',
    ouibounceModal: {
      title: 'Už odcházíte?',
      text: 'Nevadí. Vše máte uložené a můžete se sem vrátit kdykoliv později',
    },
  },
  clientInfo: {
    title: 'Pro začátek se nám představte',
    subTitle: 'Vyplňte nezávaznou žádost a dozvíte se, zda a kolik Vám můžeme půjčit.',
    firstName: 'Jméno',
    lastName: 'Příjmení',
    phoneNumber: 'Váš mobilní telefon',
    phoneNote: 'Vaše telefonní číslo potřebujeme kvůli ověření.',
    email: 'Váš e-mail',
    marketing: {
      text:
        'Souhlasím se zasíláním informací o nových a zvýhodněných {link} koncernu MONETA. Vím, že zasílání těchto zpráv mohu kdykoliv zrušit.',
      link: 'produktových nabídkách',
      modal: {
        title: 'Souhlas se zasíláním marketingových sdělení',
        text:
          'Souhlasím se zpracováním svých osobních údajů, zejména identifikačních a kontaktních údajů, informací o bankovních obchodech a údajů vzniklých v průběhu využívání produktů a služeb a dalších osobních údajů, které jsem sdělil/a, v budoucnu sdělím, nebo které jiným oprávněným způsobem získají společnosti koncernu MONETA (MONETA Money Bank, a.s., IČO: 25672720, MONETA Auto, s.r.o., IČO: 60112743, MONETA Leasing, s.r.o., IČO: 60751606 a MONETA Stavební Spořitelna, a.s., IČO: 47115289) pro přípravu nabídky na míru a oslovení s nabídkou produktů nebo služeb.',
      },
    },
    notification: {
      text:
        'Jste stávající klient MONETA Money Bank? Zažádejte o půjčku jednoduše ve Vaší Internet Bance.',
      link: 'Přihlásit se do Internet Banky',
    },
    encryption: {
      text:
        'Chci, aby se mnou koncern MONETA komunikoval na výše uvedenou e-mailovou adresu a telefonní číslo, a to běžným, {link}.',
      link: 'nešifrovaným způsobem',
      modal: {
        title: 'Souhlas se zasíláním nešifrované komunikace',
        text:
          'Souhlasím, že se mnou členové koncernu MONETA (MONETA Money Bank, a.s., IČO: 25672720, MONETA Auto, s.r.o., IČO: 60112743, MONETA Leasing, s.r.o., IČO: 60751606 a MONETA Stavební Spořitelna, a.s., IČO: 47115289) mohou komunikovat běžným způsobem, tedy nešifrovanými elektronickými a SMS zprávami, které mohou obsahovat informace o mé osobě a o obsahu a průběhu smluv uzavřených se členy koncernu MONETA.',
      },
    },
    imConsent: {
      text: 'Chci, aby se mnou koncern MONETA komunikoval běžným způsobem prostřednictvím {link}.',
      link: 'platformy WhatsApp, případně jiné platformy pro instant messaging',
      modal: {
        title: 'Souhlas s využitím instant messaging',
        text1:
          'Souhlasím, že se mnou členové koncernu MONETA (MONETA Money Bank, a.s., IČO: 25672720, MONETA Auto, s.r.o., IČO: 60112743, MONETA Leasing, s.r.o., IČO: 60751606, IČO: 60751606 a MONETA Stavební Spořitelna, a.s., IČO: 47115289) mohou komunikovat běžným způsobem prostřednictvím platformy WhatsApp, případně jiné platformy pro instant messaging, které mohou obsahovat informace o mé osobě a o obsahu a průběhu smluv uzavřených s výše uvedenými společnostmi. Seznam aktuálně využívaných platforem pro instant messaging je dostupný na stránce {link}.',
        link: 'moneta.cz/kontakt/souhlas-aplikace',
        text2:
          'Koncern MONETA se mnou bude komunikovat prostřednictvím telefonních čísel {phone1} a {phone2}.',
      },
    },
    consent: {
      text:
        'Pokračováním souhlasím s tím, že informace týkající se sjednání Express půjčky mohou být jednorázově zaslány nešifrovaným způsobem na výše uvedenou e-mailovou adresu a telefonní číslo. Dále beru na vědomí {dataProcessing} v koncernu MONETA.',
      dataProcessing: 'zásady zpracování osobních údajů',
    },
  },
  clientAddress: {
    title: 'Uveďte svou adresu',
    subTitle: 'Uveďte trvalou adresu z občanského průkazu a případně doplňte adresu kontaktní.',
    permanentAddress: 'Trvalá adresa',
    contactAddress: {
      title: 'Kontaktní adresa',
      checkboxText: 'Kontaktní adresa je jiná než trvalá',
      checkboxSubtext:
        'Pokud Vám pošta chodí na jinou adresu než trvalou, uveďte ji jako kontaktní.',
      warning: 'Kontaktní adresa musí být v České republice',
    },
  },
  FinanceProfession: {
    title: 'Vyberte hlavní zdroj příjmu',
    employmentType: 'Typ příjmu',
    occupationType: 'Profese',
    choose: 'Vyberte',
    otherDenial: {
      title:
        'Pro tento typ příjmu není možné proces dokončit online.<br/>Rádi Vám ale pomůžeme na pobočce',
      button: 'Domluvit schůzku',
    },
    bussDenial: {
      title: 'Podnikáte?<br/>Sjednejte si úvěr pro živnostníky.',
      tick1: 'Rychlý online úvěr pro živnostníky bez papírování',
      tick2: 'Schválení do 15 minut, i když nejste náš klient',
      button: 'Sjednat půjčku pro živnostníky',
    },
  },
  clientDetails: {
    formTitle: 'Vyplňte údaje z občanského průkazu',
    idCardNumber: 'Číslo občanského průkazu',
    idCardValidity: 'Platnost občanského průkazu do',
    personalNumber: 'Rodné číslo',
    maritalStatus: 'Rodinný stav',
    nationality: 'Státní občanství',
    birthPlace: 'Místo narození',
    birthCountry: 'Země narození',
    subTitleLink: 'Nechcete vyplňovat osobní údaje?',
  },
  documentInfoModal: {
    id2012: 'Občanský průkaz vzor 2012',
    personalNumber: {
      title: 'Kde najdu své RČ',
      text: 'Náhled jednotlivých variant občanského průkazu s vyznačením umístění rodného čísla.',
    },
    idCardValidity: {
      title: 'Kde najdu platnost OP?',
      text:
        'Náhled jednotlivých variant občanského průkazu s vyznačením umístění platnosti občanského průkazu.',
    },
    idCardNumber: {
      title: 'Kde najdu číslo OP?',
      text:
        'Náhled jednotlivých variant občanského průkazu s vyznačením umístění čísla občanského průkazu.',
    },
    permanentAddress: {
      title: 'Adresa trvalého bydliště',
      text: 'Adresu trvalého bydliště najdete na zadní straně občanského průkazu.',
    },
  },
  personalDataModal: {
    title: 'Bohužel, bez Vašich osobních údajů to neumíme',
    text:
      'Žádost o půjčku je nezávazná. Po jejím odeslání se dozvíte zda a kolik Vám m,ůžeme půjčit. Až potom se můžete rozhodnout, zda si půjčku u nás sjednáte.',
  },
  FinanceIncome: {
    title: 'Jaké jsou Vaše příjmy?',
    netIncomeLabel: 'Váš průměrný čistý měsíční příjem',
    netIncomeNote:
      'Uveďte průměrnou výši Vašeho čistého měsíčního příjmu za <b>poslední 4 měsíce</b>. Pokud máte nějaké <b>srážky ze mzdy</b>, např. z důvodu exekuce nebo placení výživného, odečtěte je.',
    netIncomeCompared: 'Musí být stejný nebo větší než Váš vlastní příjem',
    taxCrOnlyFlag: 'Bez toho to nepůjde',
    familyIncomeLabel: 'Průměrný čistý měsíční příjem domácnosti',
    familyIncomeNote:
      'Zadejte čistý měsíční příjem Vaší domácnosti – pokud máte každý měsíc jiný příjem, uveďte průměr za <b>poslední 4 měsíce</b>.',
    taxesInCzechia: 'Daně platím pouze v České republice',
  },
  financeExpenses: {
    formTitle: 'Jaké jsou Vaše výdaje?',
    installmentsOutsideMoneta: 'Splátky mimo MONETA Money Bank',
    installmentsOutsideMonetaNote:
      'Splácíte leasing nebo úvěr jinde než v <b>MONETA Money Bank</b>? Zadejte součet všech těchto splátek za měsíc.',
    housingExpenditure: 'Náklady na bydlení',
    housingExpenditureNote:
      'Uveďte všechny <b>pravidelné měsíční náklady spojené s bydlením</b>. Například nájem, platby za energie, vodu a další služby. <b>Pokud se o náklady dělíte, uveďte jen poměrnou část.</b> Do těchto nákladů nepatří splátky hypotéky, platby za internet, jídlo, oblečení nebo pojištění domácnosti.',
    otherCostOfLiving: 'Jiné nestandardní pravidelné výdaje',
    otherCostOfLivingNote:
      'Máte pravidelné výdaje <b>např. za léky nebo zdravotní pomůcky</b>? Napište jejich měsíční výši.',
    numberOfDependents: 'Počet vyživovaných osob',
    numberOfDependentsNote:
      'Vyživovanou osobou je každý, kdo je i jen částečně závislý na Vašem příjmu. Tedy například Vaše děti, manželka na mateřské nebo invalidní osoba, o kterou pečujete.',
    mePlus: 'Já + ',
    countPersons: '{persons, plural, one {1 osoba} few {# osoby} other {# osob}}',
    morePersons: '9 nebo více osob',
    modal: {
      title: 'Jiné nestandardní pravidelné výdaje:<br />{amount}',
      content:
        'Jste si jistí, že je to správná částka? Patří sem <b>měsíční pravidelné výdaje např. za léky nebo zdravotní pomůcky.</b>',
      secondaryButton: 'Opravit',
    },
  },
  financeEmployer: {
    title: 'Kde pracujete?',
    employer: 'Název firmy',
    identificationNumber: 'IČO',
    employedFrom: 'Pracuji zde od',
    employedTo: 'Pracovní poměr do',
    employmentTrial: 'Jsem ve zkušební době',
    employmentNotice: 'Běží mi výpovědní lhůta',
  },
  ClientAdditionalInfo: {
    formTitle: 'Teď už jen drobnosti',
    education: 'Dosažené vzdělání',
    stayOnAddressFrom: 'Na současné adrese bydlím',
    livingType: 'Typ bydlení',
    extraDocs: 'Druhý doklad totožnosti',
    drivingLicense: 'Řidičský průkaz',
    passport: 'Cestovní pas',
    pep: {
      reason: {
        title: 'Důvod politické exponovanosti',
        tooltip:
          'Uveďte funkci (případně vztah k jiné osobě), která z Vás činí politicky exponovanou osobu (např. „jsem soudce Ústavního soudu“ nebo „jsem manželka primátora města Plzeň“)',
      },
      title: 'Jste politicky exponovanou osobou?',
      tooltip:
        'Politicky exponovanou osobou se rozumí fyzická osoba, která je nebo byla ve významné veřejné funkci s celostátním nebo regionálním významem v České republice nebo v zahraničí (např. předseda vlády, člen parlamentu, významný vedoucí představitel územní samosprávy, soudce nejvyššího nebo ústavního soudu, člen bankovní rady centrální banky, vysoký důstojník ozbrojených sil). Za politicky exponovanou osobu se považuje také: 1) osoba blízká této osobě (např. rodič, dítě, sourozenec, manžel/ka nebo partner/ka), 2) společník nebo skutečný majitel stejné právnické osoby nebo svěřenského fondu jako tato osoba nebo osoba, která je s ní v jakémkoli jiném blízkém podnikatelském vztahu, 3) skutečný majitel právnické osoby nebo svěřenského fondu, které byly vytvořeny ve prospěch této osoby.',
    },
    extraDocsNote:
      'Kromě občanského průkazu budete při sjednání půjčky potřebovat i řidičský průkaz nebo pas.',
    stay: {
      below5: 'méně než 5 let',
      from5To10: '5 - 10 let',
      from10To20: '10 - 20 let',
      from20To30: '20 - 30 let',
      above30: 'více než 30 let',
    },
  },
  recapitulation: {
    email: 'E-mail',
    employerName: 'Zaměstnavatel',
    identificationNumber: 'IČO zaměstnavatele',
    title: 'Zkontrolujte údaje a žádost podepište',
    changeLoanBtn: 'Změnit nastavení půjčky',
    yourLoan: 'Vaše půjčka',
    loanAmount: 'Výše půjčky',
    loanDuration: 'Doba splácení',
    contactData: 'Kontaktní údaje',
    changeContactData: 'Změnit kontaktní údaje',
    firstNameAndLastName: 'Jméno a příjmení',
    phoneContact: 'Telefonní kontakt',
    personalData: 'Osobní údaje',
    pep: 'Politická exponovanost',
    changePersonalData: 'Změnit osobní údaje',
    address: 'Adresa',
    changeAddress: 'Změnit adresu',
    employment: 'Zdroj příjmů',
    changeEmployment: 'Změnit zdroj příjmů',
    employerAddress: 'Adresa zaměstnavatele',
    incomes: 'Příjmy',
    changeIncomes: 'Změnit údaje o příjmech',
    expenses: 'Výdaje',
    changeExpenses: 'Změnit údaje o výdajích',
    additionalInfo: 'Další údaje',
    changeAdditionalInfo: 'Změnit',
    additionalDocuments: 'Druhý doklad totožnosti',
    sendSmsKeyInfo: 'Na Váš telefon {phoneNumber} zašleme ověřovací SMS kód.',
    instalmentDay: 'Den splátky',
    changePhoneNumber: 'Změnit telefonní číslo',
    disclaimer: {
      part1:
        'Pro vyřízení Vaší žádosti o produkt je nezbytné zpracovávat Vaše osobní údaje, a to za účelem zjištění Vaší úvěruschopnosti, důvěryhodnosti a platební morálky, včetně ověření v Bankovním registru klientských informací a Nebankovním registru klientských informací, a dalších kroků nezbytných k jednání o uzavření smlouvy.',
      part2: 'Beru na vědomí {link} v koncernu MONETA (MMB) a čestně prohlašuji následující:',
      part2Link: 'zásady zpracování osobních údajů',
      part3: {
        item1:
          'všechny mnou uváděné informace a podklady jsou pravdivé, úplné, správné a aktuální. Jsem si vědom, že nepravdivost tohoto prohlášení může mít za následek vznik odpovědnosti mé, a to včetně odpovědnosti trestněprávní;',
        item2:
          'jsem nebyl/a pravomocně odsouzen/a pro trestný čin, jehož skutková podstata souvisí s mým předmětem podnikání, nebo pro trestný čin hospodářský nebo trestný čin proti majetku;',
        item3: {
          title: 'ohledně mé osoby v žádosti:',
          a:
            'nebyl prohlášen konkurz ani nejsem v úpadku nebo hrozícím úpadku, nebylo proti mně zahájeno konkurzní, vyrovnávací, insolvenční nebo jakékoli jiné soudní řízení ani nebyly učiněny kroky k jejich zahájení;',
          b:
            'nebyl zamítnut návrh na prohlášení konkurzu na majetek žadatele nebo insolvenční návrh pro nedostatek jeho majetku;',
          c: 'neprobíhá likvidace',
          d: 'neexistují v evidenci daní zachycené daňové nedoplatky;',
          e:
            'nedošlo v posledních třech letech k disciplinárnímu potrestání podle zvl. Předpisů upravující výkon odborné činnosti;',
          f:
            'neexistuje splatný nedoplatek na pojistném a na penále na veřejné zdravotní pojištění ani na pojistném a na penále na sociálním zabezpečení a příspěvku na státní politiku zaměstnanosti.',
        },
      },
      part4:
        'Zplnomocňuji tímto MMB k ověření mých údajů a k provedení dalších zjištění, která bude MMB v souvislosti se schválením této žádosti považovat za nezbytná.',
      part5:
        'Beru na vědomí, že mi je poskytováno doporučení nikoliv rada podle zákona o spotřebitelském úvěru.',
    },

    footer: {
      continueBtn: 'Vše souhlasí, potvrdit žádost',
      changePhoneNumber: 'Změnit telefonní číslo',
      sendSmsCodeInfo: 'Na Váš telefon {phoneNumber} zašleme ověřovací SMS kód.',
      sentSmsCodeInfoV1: 'SMS jsme Vám poslali na číslo {phoneNumber}',
      sentSmsCodeInfoV2: 'Zaslali jsme Vám novou SMS s ověřovacím kódem',
      requestSmsError: 'Odeslání nové SMS se nezdařilo. Zkuste to, prosím, znovu.',
      sendSmsError: 'Podepisování se nezdařilo. Zkuste to, prosím, znovu.',
      sendSmsErrorValidation:
        'Podepisování se nezdařilo, protože v ověřovacím SMS kódu je následující chyba: {reason}',
      sendSmsErrorExpired:
        'Platnost ověřovacího SMS kódu vypršela. Vygenerujte si novou SMS a akci opakujte.',
      sendSmsErrorInvalid: 'Byl zadán neplatný SMS kód',
      sendSmsErrorOverCounted: 'Překročili jste maximální počet pokusů.',
      sendSmsAgain: 'Poslat novou SMS',
      putSmsCode: 'Vložte ověřovací SMS kód',
    },
    telcoScoringConsent: {
      title: 'Zvyšte si šanci na získání úvěru',
      checkbox: {
        text: 'Souhlasím s {link} od mobilního operátora',
        link: 'využitím informací',
      },
      description: {
        title: 'Jak to funguje?',
        text:
          'Díky dodatečným informacím od Vašeho mobilního operátora budeme schopni lépe posoudit Vaši úvěroschopnost a tím rychleji a přesněji vyhodnotit Vaši žádost o úvěr.',
      },
    },
  },
  InsuranceQuestion: {
    title: 'Opravdu chcete půjčku sjednat bez pojištění?',
    subTitle: 'Nepodceňujte rizika, komplexní ochrana Vás přijde jen na {amount} Kč měsíčně',
    bullet1: 'Ochrana při pracovní neschopnosti a ztrátě zaměstnání',
    bullet2: 'V případě potřeby Vám proplatíme již první splátku',
    bullet3: 'Pomůžeme, i když se budete muset starat o člena rodiny',
    bullet4: 'Když dojde na nejhorší, zaplatíme celý úvěr',
    moreInfo: 'Více o pojištění',
    withInsurance: 'Sjednat bez pojištění',
    withoutInsurance: 'Sjednat s pojištěním',
  },
  ReturnProcessDetected: {
    title: 'Máte uložený stav z poslení návštěvy',
    description: 'Máte následující možnosti pokračování',
    newProcessBtn: 'Začít od začátku',
    existingProcessBtn: 'Pokračovat ve sjednání',
  },
  ClientScoring: {
    title: 'Vyhodnocujeme Vaši žádost',
    text:
      'Po vyhodnocení se dozvíte, zda a kolik Vám můžeme půjčit.</br>Obvykle nám to zabere jen několik vteřin.',
  },
  LeaveConfirmation: {
    title: 'Upozornění',
    description:
      'V procesu se nelze vracet. Ukončením přijdete o vložené hodnoty a bude nutné proces začít znovu.',
    leave: 'Ukončit proces',
    stay: 'Pokračovat v procesu',
  },
  inactivityDialogLogout: {
    title: 'Z bezpečnostních důvodů jsme Vás odhlásili',
    subtitle: 'Chcete se vrátit k rozdělané práci?',
    button: 'Zpět na žádost',
  },
  inactivityDialog: {
    title: 'Z bezpečnostních důvodů Vás odhlásíme za',
    subtitle: 'Chcete pokračovat v rozdělané práci?',
    exit: 'Uložit na později',
    close: 'Jsem zpět',
  },
  popUpload: {
    title: 'Nahrajte výpisy z účtu za poslední 4 měsíce',
    perex:
      'Stačí nahrát výpisy za poslední 4 měsíce z účtu, na který Vám chodí výplata. Výpisy stáhnete ze svého internetového bankovnictví.',
    tooltip:
      'Nevíte, kde najít výpisy? Kontaktujte zákaznickou podporu své banky. Určitě Vám poradí.',
    uploadDragOr: 'Přetáhněte soubory sem nebo ',
    selectFiles: 'vyberte soubory',
    note: 'Dokumenty musí být ve formátu PDF, digitálně podepsané Vaší bankou',
    remove: 'Odebrat',
    upload: 'Odeslat výpisy',
    modal: {
      saveFail: {
        title: 'Bohužel se nám nepodařilo soubor uložit',
        content: 'Někde došlo k chybě, zkuste prosím soubor nahrát znovu.',
        closeButton: 'Zrušit',
        buttonRetry: 'Zkusit znovu',
      },
      filesCount: {
        title:
          'Nahráli jste jen {fileCount, plural, one {# soubor} few {# soubory} other {# souborů}}',
        content:
          'Pro doložení příjmů potřebujeme vidět všechny Vaše transakce za poslední 4 měsíce. Každá banka generuje výpisy v jiné frekvenci a může tak jít o 1 až 4 soubory.',
        lastQuestion: 'Máme všechny Vaše výpisy?',
        closeButton: 'Ano, odeslat',
        secondButton: 'Ne, nahrát další',
      },
      wrongFile: {
        title: 'Nahraný dokument nemůžeme použít, nahrajte prosím jiný',
        content: 'Soubor musí být ve formátu PDF, maximální velikost je 20 MB.',
        closeButton: 'Zrušit',
      },
    },
  },
  printContract: {
    titleA: 'Připravujeme ',
    titleB: 'smlouvy',
    titleC: '<br />k zakládaným produktům',
    subTitle: 'Zabere nám to jen několik vteřin.',
    warning: 'Nezavírejte tuto stránku. ',
  },
  printPreContract: {
    titleA: 'Připravujeme ',
    titleB: 'dokumenty',
    titleC: '<br />k zakládaným produktům',
    subTitle: 'Zabere nám to několik minut.',
    warning: 'Nezavírejte tuto stránku. ',
  },
  preContract: {
    notification: 'Předsmluvní informace jsme Vám poslali na e-mail {email}',
    title: 'Projděte si dokumenty k zakládaným produktům',
    perex: 'Následující informace by Vás mohly zajímat. Dokumenty pak podepíšete SMS kódem.',
    documents: {
      signature: {
        title: 'Smlouva o sjednání elektronického podpisu',
        text: 'Na tomto místě se domluvíme, jakým způsobem budete podepisovat důležité dokumenty.',
      },
      preContractAccount: {
        title: 'Předsmluvní informace k platebním účtům a platebnímu styku',
        text:
          'V tomto dokumentu se dozvíte podrobnosti o Vašem novém běžném účtu a poplatcích, které je dobré znát ještě před podpisem samotné smlouvy.',
      },
      preContractLoan: {
        title: 'Předsmluvní informace k úvěru',
        text:
          'Zde najdete podmínky Vaší půjčky. Prostudujte si je ještě před tím, než spolu podepíšeme samotnou smlouvu.',
      },
    },
    continue: 'Rozumím a souhlasím',
  },
  contract: {
    title: 'Projděte si smlouvy k zakládaným produktům',
    perex: 'Následující informace by Vás mohly zajímat. Dokumenty pak podepíšete SMS kódem.',
    documents: {
      product: {
        title: 'Smlouva o bankovních produktech a službách',
        text:
          'V tomto dokumentu si závazně odsouhlasíme podmínky produktů a služeb, které si právě sjednáváte.',
      },
      loan: {
        title: 'Smlouva o úvěru',
        text: 'Zde si definitivně potvrdíme, jakou půjčku a za jakých podmínek si sjednáváte.',
      },
    },
    continue: 'Rozumím a souhlasím',
  },
  ContractSign: {
    title: 'Teď to musíme podepsat my',
    subTitle: 'Nezavírejte tuto stránku. Zabere nám to jen několik vteřin.',
  },
  pennyPayment: {
    title: 'Uveďte svůj účet, ze kterého pošlete aktivační převod {amount} Kč.',
    notification: 'Výborně, Předsmluvní informace a Smlouvy byly podepsány',
    info:
      'Abyste mohli čerpat peníze z půjčky, založíme Vám běžný účet. Aktivační převod je nutný pro ověření, že tento účet zakládá existující fyzická osoba. Váš nový běžný účet proto aktivujeme až v okamžiku, kdy se na něj připíše {amount} Kč. Zároveň na něj dojde k načerpání Vaší půjčky.',
    account: {
      title: 'Váš stávající účet',
      prefix: 'Předčíslí',
      number: 'Zadejte číslo Vašeho účtu',
      bank: 'Kód banky',
    },
    confirm:
      'Potvrzuji, že právě zadaný účet je veden na mé jméno u banky v ČR a že jsem ho otevřel/a osobně na pobočce',
    continue: 'Pokračovat',
  },
  pennyPaymentConfirm: {
    info:
      'Váš nový běžný účet, na který Vám půjčku načerpáme, aktivujeme v momentě, kdy se na něj připíše {amount} Kč z Vámi uvedeného účtu. O aktivaci účtu a načerpání půjčky Vám napíšeme e-mail a pošleme Vám i přihlašovací údaje.',
    instant:
      'Pokud to Vaše banka umožňuje, můžete platbu poslat jako okamžitou. Zrychlíte tím aktivaci produktu.',

    continue: 'Potvrzuji odeslání platby',

    manual: {
      amount: 'Částka',
      dueDate: 'Nejpozději do',
      fromAccount: 'Z Vašeho účtu',
      tab: 'Údaje pro manuální platbu',
      title: 'Odešlete aktivační platbu s <span>povinnou zprávou pro příjemce</span>',
      toAccount: 'Na účet',
      transactionNote: 'Zpráva pro příjemce (pro potvrzení Vašeho zájmu o sjednání produktu)',
      variableSymbol: 'Variabilní symbol',
      warning:
        'Ujistěte se, že platbu zadávete <b>včetně Zprávy pro příjemce</b> ve správném tvaru a že platbu posíláte <b>z Vašeho účtu {accountNumber}</b>',
    },
    qr: {
      doesntWork: {
        link: 'Poslat platbu manuálně',
        text: 'Máte potíže s QR platbou?',
      },
      step1: 'Na telefonu spusťte aplikaci banky, ze které chcete provést platbu',
      step2: 'Zvolte platbu QR kódem a naskenujte jej z této obrazovky',
      step3: 'Automaticky se vyplní platební příkaz, který jen potvrdíte',
      tab: 'QR platba',
      title: 'Odešlete aktivační platbu',
      warning:
        'Ujistěte se, že platbu opravdu odesíláte z <b>Vašeho účtu číslo {accountNumber}</b>',
    },
  },
  okBranch: {
    button: 'Domluvit schůzku na pobočce',
    notification: 'Následující informace jsme Vám taky poslali na Vaši e-mailovou adresu',
    perex: 'Abychom Vám mohli poslat peníze na účet, <b>stavte se k nám na pobočku</b>.',

    title: 'Výborně, Vaše žádost je schválená',
  },
  final: {
    title: 'Výborně, brzy budete moci začít půjčku čerpat',
    perex:
      'Váš nový běžný účet, na který Vám půjčku načerpáme, aktivujeme v momentě, kdy se na něj připíše {amount} Kč. Debetní kartu k běžnému účtu obdržíte poštou.',
    next: {
      title: 'Co bude dál?',
      perex:
        'Až se na Váš nový běžný účet připíše {amount} Kč, pošleme Vám znovu veškeré užitečné informace a navíc:',
      sms: 'SMSkou Vám pošleme heslo',
      email: 'Na e-mail Vám odešleme přihlašovací jméno ',
      ib: 'Ve své online správě najdete Smlouvu',
    },
    notification: 'Tuto stránku můžete zavřít',
  },
  ChooseBranch: { title: 'Pobočky a bankomaty máme tam, kde potřebujeme' },
  loanConfigurator: {
    emailSent: 'Shrnutí schválené půjčky jsme Vám poslali na e-mail <strong>{email}</strong>',
    ibInfo:
      'V případě, že máte Internet Banku, tak Vám k dokočení stačí pouze podpis v Internet Bance.',
    titleApproved: 'Výborně, Vaše žádost je schválená',
    subTitleApproved: {
      OK: ' ',
      OK_MORE: 'A můžeme Vám půjčit dokonce až {maxAmount}',
      OK_LESS: 'Půjčit Vám ale můžeme jen {maxAmount}',
    },
    titleDefault: 'Změna parametrů půjčky',
    titleIsMissing: 'Vyberte, prosím,<br/> základní parametry půjčky',
    loanTitle: 'Vaše půjčka',
    loanAmount: 'Výše půjčky',
    term: 'Počet měsíčních splátek',
    instalment: 'Měsíční splátka',
    interestRate: 'Roční úroková míra',
    rpsn: 'RPSN',
    feeAmount: 'Poplatek za sjednání',
    totalAmount: 'Celkem zaplatíte',
    insurance:
      'Chci k úvěru sjednat pojištění schopnosti splácet jen za {monthlyPayment} Kč měsíčně',
    insuranceLink: 'Více o pojištění',
    rescoringTitle: 'Přenastavení parametrů úvěru',
    rescoringSubtitle: 'Po doložení všech dokumentů jsme museli provést přepočet nabídky.',
    termSliderRangeFrom: 'měsíců',
    termSliderRangeTo: 'měsíců',
    instalmentDay: 'Den splátky',
    roundedLoanInfo:
      'Velikost půjčky byla zaokrouhlena z "{loanRoundedFrom}" na "{loanRoundedTo}".',
    roundedTermInfo:
      'Počet měsíčních splátek byl zaokrouhlen z "{termRoundedFrom}" na "{termRoundedTo}".',

    footer: {
      callUs: 'Potřebujete více informací?<br />Volejte na:',
      finishIb: 'Přihlásit se do Internet Banky',
      finishOnline: 'Sjednat online',
      visitUs: 'Dáváte přednost sjednání<br />na pobočce?',
      visitUsLink: 'Domluvit schůzku',
    },
  },
  docsInfo: {
    title: 'Na pobočku si s sebou vezměte:',
    idCard: 'Občanský průkaz',
    otherId: 'Druhý průkaz totožnosti, který jste uvedl/a v žádosti',
    incomeLink: 'Potvrzení o výši příjmu',
    income: 'potvrzené Vaším zaměstnavatelem',
    goToBranches: 'Domluvit schůzku',
  },
  NotFound: {
    title: 'Stránka nenalezena – 404',
    mainMessage: 'Bohužel stránka, na kterou jste přistoupil, nic neobsahuje.',
    newLoan: 'Pro zadání nové půjčky jděte na ',
    moreInfo: 'Pro více informací a domluvení na konkrétním postupu kontaktujte infolinku.',
    call: 'Zavolejte nám ',
  },
  clientChecks: {
    title: 'Jak bude online sjednání půjčky probíhat',
    incomeCheck: {
      title: 'Doložení příjmu',
      text:
        'Stačí nahrát výpisy za poslední 4 měsíce z účtu, na který Vám chodí výplata. Výpisy stáhnete ze svého internetového bankovnictví.',
      link: 'Potvrzení o výši příjmů.',
    },
    identityCheck: {
      title: 'Ověření identity přes mobil',
      text:
        'Pomocí kamery Vašeho mobilního telefonu nafotíte občanský průkaz a druhý doklad totožnosti, který jste uvedli v žádosti. Pomocí kamery také ověříme, zda Vaše tvář souhlasí s fotografií na dokladech.',
    },
    fraudCheck: {
      title:
        'Ověřujeme Vaše příjmy, vraťte se prosím později.<br/>Po dokončení Vás budeme informovat a budete moci pokračovat ve sjednání.',
    },
    agreements: {
      title: 'Podpis dokumentů SMS kódem',
      text:
        'Předsmluvní informace a smlouvy k zakládaným produktům podepíšete jednoduše přes SMS kód.',
    },
    paymentCheck: {
      title: 'Aktivační převod',
      text:
        'Abyste mohli čerpat peníze z půjčky, založíme Vám běžný účet. Pro jeho aktivaci je nutný převod symbolické 1 Kč z jiného účtu vedeného na Vaše jméno v jakékoli české bance.',
    },
    money: {
      title: 'A peníze jsou Vaše',
      text:
        'Peníze budete mít k dispozici na svém novém běžném účtu, ke kterému Vám, na Vaši kontaktní adresu, přijde i debetní karta.',
    },
    buttons: {
      branch: 'Uložit a ukončit',
      online: 'Pokračovat v online sjednání',
    },
    note: {
      title: 'Spolu s půjčkou Vám založíme běžný účet',
      perex:
        'Abyste mohli čerpat peníze z půjčky, založíme Vám zdarma běžný účet spolu s Internet Bankou pro jeho správu.',
      bullet1: 'Založení účtu je zdarma',
      bullet2: 'Vedení účtu je také zdarma',
      bullet3: 'Tuzemské transakce zadané elektronicky zdarma',
    },
  },
  koOnline: {
    title: 'Online už to dál nepůjde',
    desc:
      'Cestou se něco pokazilo a dokončit sjednání online není možné. Sjednejte si schůzku na naší pobočce, nebo nám zavolejte pro více informací o dalším postupu.',
  },
  ExitScreen: {
    regular: {
      logoutMsg: 'Údaje jsme uložili a úspěšně Vás odhlásili',
      title: 'K rozpracované žádosti se můžete kdykoli vrátit',
      subtitle:
        'Pokud se k žádosti vrátíte na tomto zařízení, budete si moct vybrat, jestli chcete pokračovat, kde jste skončili, nebo začít znovu od začátku. Když budete chtít pokračovat, zadáte SMS kód, který Vám pošleme na telefonní číslo, které jste zadali v žádosti. Vaše údaje pak už budou předvyplněné.',
      link: 'Zpět do žádosti',
    },
    afterScoring: {
      logoutMsg: 'Všechny údaje jsme uložili a úspěšně Vás odhlásili',
      title:
        'Do 14 dnů od schválení žádosti se sem můžete vrátit a pokračovat tam, kde jste nyní skončili',
      subtitle:
        'Pro návrat použijte odkaz, který jsme Vám poslali na e-mail společně se schválenou žádostí o půjčku. Po otevření odkazu zadáte SMS kód, který Vám pošleme na telefonní číslo, které jste zadali v žádosti.',
      link: 'Zkopírovat odkaz',
    },
  },
  identity: {
    intro: {
      title: 'Teď potřebujeme ověřit Vaši identitu',
      text:
        'Pomocí kamery Vašeho mobilního telefonu nafotíte občanský průkaz a druhý doklad totožnosti, který jste uvedli v žádosti. Pomocí kamery také ověříme, zda Vaše tvář souhlasí s fotografií na dokladech.',
      subHeader: 'Co budete potřebovat?',
      idCard: 'Platný občanský průkaz',
      drivingLicence: 'Platný řidičský průkaz nebo pas',
      mobilePhone: 'Chytrý telefon s kamerou a připojením k internetu',
      modalLink: 'Nechcete ověřit svoji identitu online?',
    },
    sms: {
      title: 'Pokračujte na mobilním telefonu',
      subtext:
        'Na Vaše telefonní číslo <strong>{phoneNumber}</strong> jsme v SMS zaslali pokyny k dalšímu postupu a odkaz. <strong>Pokračujte otevřením tohoto odkazu v SMS.</strong>',
      qrCode: 'QR kód:',
      warning:
        '<strong>Nezavírejte tuto stránku.</strong> Budeme zde pokračovat, až své doklady dofotíte. Zavření stránky by zrušilo Váš dosavadní postup.',
      noSms: 'SMS nedorazila? ',
      sendSms: 'Pošlete mi SMS znovu',
    },
    modal: {
      title: 'Ověření identity online',
      cons:
        'Pokud Vaše doklady a Vaši tvář neověříme online, bude nutné dokončit sjednání na pobočce',
      pros:
        'Pokud Vaši identitu ověříme online, zvládneme společně dokončit <b>sjednání během několika minut a bez návštěvy pobočky</b>',
    },
  },
  popProcessing: {
    title: 'Zpracováváme přiložené výpisy',
    text: 'Probíhá zpracování výpisů z účtu.<br /> Zabere nám to jen několik vteřin.',
  },
  postProcessing: {
    title: 'Ještě ověřujeme Vaše příjmy',
    text: 'Zabere nám to několik minut.',
    notification:
      'Tuto stránku můžete zavřít. Až budeme mít hotovo, pošleme Vám informativní SMS a Vy poté můžete pokračovat ve sjednání online.',
  },
  SaveAndReturn: {
    resetContinueTitle: 'Máte uložený stav z poslední návštěvy',
    resetContinueSubtitle: 'Máte následující možnosti pokračování',
    resetBtn: 'Začít od začátku',
    continueBtn: 'Pokračovat ve sjednání',
    smsCodeTitle: 'Pro pokračování vložte kód, který jste dostali do SMS',
    smsCodeSent: 'Na Váš telefon {phoneNumber} jsme již dříve zaslali ověřovací SMS kód.',
    newSmsCodeSent: 'Nová SMS byla odeslána na Vaše tel. číslo {phoneNumber}.',
    smsCode: 'SMS kód',
    smsCodeInvalid: 'Neplatný SMS kód',
    sendAgain: 'Poslat SMS znovu',
  },
  smsVerify: {
    title: 'Podepište dokumenty SMS kódem',
    codeLocked:
      'Vyčerpali jste počet pokusů pro vložení aktuálního SMS klíče.<br/> Pošlete si prosím nový klíč na Váš telefon {phone}.',
    toSign: 'Podepsat',
    newSms: 'Poslat novou SMS',
    insertCode: 'Vložte ověřovací SMS kód',
    invalidCode: 'Neplatný SMS kód',
    sign: 'Podepsat',
    errors: {
      ko: {
        btn: 'Zažádat o novou půjčku',
        text:
          'Z bezpečnostních důvodů není možné pokračovat. Vaše žádost byla stornována. Pro vyřízení nové půjčky zadejte novou žádost.',
        title: 'Překročili jste maximální počet pokusů',
      },
      locked: {
        btn: 'Poslat SMS kód znovu',
        text: 'Nechte si poslat SMS kód znovu',
        title: 'Zadali jste 5krát nesprávný kód',
      },
      timeout: {
        btn: 'Poslat SMS kód znovu',
        text: 'Nechte si poslat novou SMS znovu',
        title: 'Platnost SMS kódu vypršela',
      },
    },
    sendResponse: {
      usePreviousCode: 'Na Váš telefon {phone} jsme již dříve zaslali ověřovací SMS kód.',
      smsSent: 'Na Váš telefon {phone} byl zaslán ověřovací SMS kód.',
    },
  },
  TelcoScoringConsentModal: {
    title: 'Souhlas s využitím informací od mobilního operátora',
    text:
      'Souhlasím s tím:<br/><b>a)</b> aby MONETA Money Bank, a.s., IČO: 25672720 v souvislosti s mou žádostí o uzavření smlouvy předala mé telefonní číslo a/nebo rodné číslo operátorům: O2 Czech Republic a.s., IČO: 60193336 a virtuálnímu operátorovi O2 Family, s.r.o., IČO: 24215554 (100 % dceřiná společnosti O2 Czech Republic a.s.), T-Mobile Czech Republic, a.s., IČO: 64949681 a Vodafone Czech Republic a.s., IČO: 25788001;<br/><br/><b>b)</b> operátoři jednotlivě zpracovali mé telefonní a/nebo rodné číslo za účelem vytvoření agregované informace vypočtené z údajů o způsobu využití služeb elektronických komunikací (platbách, druhu, množství, místě) vedených na mou osobu nebo z údajů o způsobu využití služeb elektronických komunikací poskytovaných na telefonním čísle, jehož jsem uživatelem, a předali tuto agregovanou informaci firmě MONETA Money Bank, a.s. za účelem posouzení mé schopnosti a ochoty plnit své závazky. Prohlašuji, že telefonní číslo uvedené v žádosti je v mém výlučném osobním užívání.<br/><br/>Jsem si vědom/a, že souhlas mohu odvolat na obchodním místě MONETA Money Bank, a.s.',
  },
}
